import { configureStore } from "@reduxjs/toolkit";
import useReducer from "./authRedux";
import BlogReducer from './blog'
import WebinarReducer from './Webinar'
import { combineReducers } from "@reduxjs/toolkit";
import highlightIndex from './menuHighlight'


import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from 'redux-persist';

import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key:"root",
    version:1,
    storage:storage
}

const combined_reducers = combineReducers({
        user: useReducer,
        blog:BlogReducer,
        highlight:highlightIndex,
        webinar:WebinarReducer
        
})

const persistedReducer = persistReducer(persistConfig,combined_reducers);

export const store =  configureStore({
    reducer: persistedReducer,
    middleware:(getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck:{
            ignoreActions: [FLUSH,REHYDRATE,PAUSE,PERSIST,PURGE,REGISTER]
        }
    })
})

export const persistor = persistStore(store)